import React, { useMemo } from 'react'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'
import MerchandiseOfferCarousel from './MerchandiseOfferCarousel'
import useMerchandiseBrand from 'hooks/Merchandise/useMerchandiseBrand'
import { getMerchandiseBrandSearchUrl } from '../merchandiseUtils'

interface Props {
  brandName: string
  trackingPageName: string
}

function MerchandiseBestOfBrandCarousel({ trackingPageName, brandName }: Props) {
  const [brandsList] = useMerchandiseBrandsList({ name: brandName })
  const [brand] = useMerchandiseBrand(brandsList[0])

  const filters = useMemo(() => {
    if (!brand) return
    return {
      brands: [brand?.id]
    }
  }, [brand])

  const titleConfig = useMemo<{ node: React.ReactNode; tracking: string }>(() => {
    if (!brand) {
      return { node: null, tracking: '' }
    }

    switch (brand.name) {
      case 'Apple':
        return {
          node: <>Shop the latest from <em>{brand.name}</em></>,
          tracking: `Shop the latest from ${brand.name}`,
        }
      case 'Smeg':
        return {
          node: <>Iconic appliances by <em>{brand.name}</em></>,
          tracking: `Iconic appliances by ${brand.name}`,
        }
      case 'Samsonite':
        return {
          node: <>Travel in style with <i>{brand.name}</i></>,
          tracking: `Travel in style with ${brand.name}`,
        }
      default:
        return {
          node: <>Discover the best of <em>{brand.name}</em></>,
          tracking: `Discover the best of ${brand.name}`,
        }
    }
  }, [brand])

  if (brand?.name !== brandName) {
    return null
  }

  return (
    <MerchandiseOfferCarousel
      title={titleConfig.node}
      viewAllTo={getMerchandiseBrandSearchUrl(brand)}
      trackingListName={titleConfig.tracking}
      trackingPageName={trackingPageName}
      filters={filters}
    />
  )
}

export default MerchandiseBestOfBrandCarousel
